import {
  adobeIdStore,
  basePropertyStore,
  eventCenterStateStore,
  freeviewStateStore,
  gameCenterStateStore,
  pageInfoState,
  persistentPropertyStore,
  userPropertyStore,
  vodStateStore,
} from 'apolloGraphql/mml-apollo-cache';
import { useCallback, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useAuthWrapper } from '../components/VideoPlayer/tve/useAuthWrapper';
import { FreeViewStateNames } from 'components/VideoPlayer/tve/freeview-states';
import { UserStatusAuth } from 'state-machines/analytic-states';
import { AuthStateNames } from 'components/VideoPlayer/tve/auth-states';
import { datadogRum } from '@datadog/browser-rum';
import usePrevious from './usePrevious';
import { AnalyticsUtil } from 'utils/AnalyticsUtil';

export enum screenViewIndex {
  watch = 0,
  settings = 1,
  bracket = 2,
  scores = 3,
  bracketchallenge = 4,
  bcgdashboard = 5,
  bcgqrcode = 6,
  bcgbracket = 7,
  support = 8,
  logout_provider = 9,
  select_provider = 10,
  donotsell = 11,
  waystowatch = 12,
  game = 13,
  event = 14,
  multigame = 15,
  shop = 16,
  vod = 17,
  unknown = 18,
  gamecenter_get_access = 19,
  multigame_get_access = 20,
  ad_choices = 21,
  privacy_policy = 22,
} // making an enum so don't have to guess array index
export const screenViews = [
  {
    pageName: 'Watch',
    section: 'watch',
    subsection: 'watch',
    url: 'ncaa:watchmml:watch',
    path: '/',
    title: 'Watch',
    ddName: 'watch_page',
  },
  {
    pageName: 'Settings',
    section: 'settings',
    subsection: 'settings',
    url: 'ncaa:watchmml:settings',
    path: '/settings',
    title: 'Settings',
    ddName: 'settings_page',
  },
  {
    pageName: 'Official Bracket',
    section: 'scores',
    subsection: 'scores:bracket',
    url: 'ncaa:watchmml:scores:bracket',
    path: '/bracket',
    title: 'Official Bracket',
    ddName: 'bracket_page',
  },
  {
    pageName: 'Schedule',
    section: 'scores',
    subsection: 'scores:schedule',
    url: 'ncaa:watchmml:scores:schedule',
    path: '/scores',
    title: 'Schedule',
    ddName: 'scores_page',
  },
  {
    pageName: 'bcg registration landing',
    section: 'bcg',
    subsection: 'bcg:registration',
    url: 'ncaa:watchmml:bcg:registration',
    path: '/bracketchallenge',
    title: 'bcg registration landing',
    ddName: 'bcg_page',
  },
  {
    pageName: 'bcg dashboard',
    section: 'bcg',
    subsection: 'bcg:dashboard',
    url: 'ncaa:watchmml:bcg:dashboard',
    path: '/bcgdashboard',
    title: 'bcg dashboard',
    ddName: 'bcgdashboard_page',
  },
  {
    pageName: 'bcg qr code',
    section: 'bcg',
    subsection: 'bcg:dashboard',
    url: 'ncaa:watchmml:bcg:dashboard:bcg_qr_code',
    path: '/bcgqrcode',
    title: 'bcg qr code',
    ddName: 'bcgqrcode_page',
  },
  {
    pageName: 'bcg bracket detail',
    section: 'bcg',
    subsection: 'bcg:bracket',
    url: 'ncaa:watchmml:bcg:bracket:bcg_bracket_detail',
    path: '/bcgbracket',
    title: 'bcg bracket detail',
    ddName: 'bcgbracket_page',
  },
  {
    pageName: 'Support',
    section: 'settings',
    subsection: 'settings:support',
    url: 'ncaa:watchmml:settings:support',
    path: '/support',
    title: 'Support',
    ddName: 'support_page',
  },
  {
    pageName: 'logout provider',
    section: 'settings',
    subsection: 'settings:logoutprovider',
    url: 'ncaa:watchmml:settings:logoutprovider',
    path: '/logoutprovider',
    title: 'Logout provider',
    ddName: 'logoutprovider_page',
  },
  {
    pageName: 'select provider',
    section: 'settings',
    subsection: 'settings:selectprovider',
    url: 'ncaa:watchmml:settings:selectprovider',
    path: '/selectprovider',
    title: 'Select provider',
    ddName: 'selectprovider_page',
  },
  {
    pageName: 'do not sell',
    section: 'settings',
    subsection: 'settings:donotsell',
    url: 'ncaa:watchmml:settings:donotsell',
    path: '/donotsell',
    title: 'do not sell',
    ddName: 'donotsell_page',
  },
  {
    pageName: 'ways to watch',
    section: 'settings',
    subsection: 'settings:ways_to_watch',
    url: 'ncaa:watchmml:settings:ways_to_watch',
    path: '/waystowatch',
    title: 'ways to watch',
    ddName: 'ways_to_watch_page',
  },
  {
    pageName: 'game center',
    section: 'gamecenter',
    subsection: 'gamecenter:game',
    url: 'ncaa:watchmml:gamecenter:game:<gameID>',
    path: '/game',
    title: 'game center',
    gameID: '',
    channel: '',
    gameState: '',
    ddName: 'game_page',
  },
  {
    pageName: 'game center',
    section: 'gamecenter',
    subsection: 'gamecenter:event',
    url: 'ncaa:watchmml:gamecenter:event:<eventID>',
    path: '/event',
    title: 'game center',
    gameID: '',
    ddName: 'event_page',
  },
  {
    pageName: 'multiview',
    section: 'multiview',
    subsection: 'multiview',
    url: 'ncaa:watchmml:multiview',
    path: '/multigame',
    title: 'multiview',
    ddName: 'multiview_page',
  },
  {
    pageName: 'shop',
    section: 'shop',
    subsection: 'shop',
    url: 'ncaa:watchmml:shop',
    path: '/shop',
    title: 'shop',
    ddName: 'shop_page',
  },
  {
    pageName: 'VOD Playlist',
    section: 'watch',
    subsection: 'watch:vod',
    url: 'ncaa:watchmml:watch:vod:playlist:<title>',
    path: '/video',
    title: 'VOD Playlist',
    ddName: 'vod_page',
  },
  {
    section: 'unknown',
    subsection: 'unknown',
    url: 'unknown',
    path: '/default',
    title: '',
    ddName: null,
  },
  // Items below are not real routes.  They are defined in spec
  // as screen views so we track them as such.
  {
    pageName: 'get access gamecenter',
    section: 'gamecenter',
    subsection: 'gamecenter:get_access',
    url: 'ncaa:watchmml:gamecenter:get_access',
    path: '/gamecenter_get_access',
    title: 'get access gamecenter',
    ddName: 'gamecenter_get_access_page',
  },
  {
    pageName: 'get access multiview',
    section: 'multiview',
    subsection: 'multiview:get_access',
    url: 'ncaa:watchmml:multiview:get_access',
    path: '/multigame_get_access',
    title: 'get access multiview',
    ddName: 'multigame_get_access_page',
  },
  {
    pageName: 'ad choices',
    section: 'settings',
    subsection: 'settings:adchoices',
    url: 'ncaa:watchmml:settings:adchoices',
    path: '/adchoices',
    title: 'ad choices',
    ddName: 'ad_choices_page',
  },
  {
    pageName: 'privacy policy',
    section: 'settings',
    subsection: 'settings:privacypolicy',
    url: 'ncaa:watchmml:settings:privacypolicy',
    path: '/privacypolicy',
    title: 'privacy policy',
    ddName: 'privacy_policy_page',
  },
];

export function useAnalytics(): void {
  const pageInfo = useReactiveVar(pageInfoState);
  const persistentPropertyState = persistentPropertyStore();
  const userPropertyState = useReactiveVar(userPropertyStore);
  const authProperties = useAuthWrapper().authStateMachine;
  const freeViewState = useReactiveVar(freeviewStateStore);
  const gameCenterState = useReactiveVar(gameCenterStateStore);
  const eventCenterState = useReactiveVar(eventCenterStateStore);
  const vodState = useReactiveVar(vodStateStore);

  const previousPageInfo = usePrevious(pageInfo);
  const adobeId = useReactiveVar(adobeIdStore);

  const updateBasePropertiesForScreenView = useCallback(
    (path: string, referrer: string) => {
      let info = screenViews
        .filter((item) => {
          if (path.indexOf('/bcgbracket') > -1) {
            return item.path === '/bcgbracket';
          } else if (path.indexOf('/game/') > -1) {
            return item.path === '/game';
          } else if (path.indexOf('/event/') > -1) {
            return item.path === '/event';
          } else if (path.indexOf('/multigame/') > -1) {
            return item.path === '/multigame';
          }
          return item.path === path;
        })
        .map((item) => {
          if (item.ddName === 'game_page') {
            item.url = `ncaa:watchmml:gamecenter:game:${gameCenterState.bracketId.toString()}`;
            item.gameID = gameCenterState.bracketId.toString();
            item.gameState = gameCenterState.gameState;
            item.channel = gameCenterState.broadcaster ?? '';
          } else if (item.ddName === 'event_page') {
            item.url = `ncaa:watchmml:gamecenter:event:${eventCenterState.bracketId.toString()}`;
            item.gameID = eventCenterState.bracketId.toString();
          } else if (item.ddName === 'vod_page') {
            item.url = `ncaa:watchmml:watch:vod:playlist:${vodState.video.title}`;
          }
          return item;
        });

      info = !info.length ? screenViews.filter((item) => item.path === '/default') : info;

      const baseProperties = basePropertyStore({
        ...basePropertyStore(),
        ...info[0],
        adobeId,
        timestamp: Date.now().toString(),
        path: info[0].pageName ?? path,
        referrer,
      });

      return { baseProperties, info };
    },
    [gameCenterState, eventCenterState, vodState, adobeId],
  );

  useEffect(() => {
    // Gather screenview data
    const screenData = updateBasePropertiesForScreenView(pageInfo.path, pageInfo.referrer);
    if (pageInfo.path !== '' && pageInfo.path !== previousPageInfo?.path) {
      // Only track a page view once per path
      AnalyticsUtil.page({ name: screenData.info[0].ddName as string, properties: {} });
    }

    if (screenData.info[0].ddName) {
      // Update DD values whenever they change to override the default
      // viewName coming from react router.
      // Example view name change: /game/204 -> game_page
      datadogRum.setViewName(screenData.info[0].ddName);
      // And also various parts of the data that change after page load.
      datadogRum.setViewContext({ ...screenData.baseProperties });

      // We are sending the full trackingData to DD above but specs say
      // to only send the fields below.  Leaving this here incase we need
      // to switch back
      // datadogRum.setViewContext({
      //   ...(baseProperties.section && { section: baseProperties.section }),
      //   ...(baseProperties.subsection && { subSection: baseProperties.subsection }),
      //   ...(baseProperties.url && { url: baseProperties.url }),
      //   ...(baseProperties.gameID && { gameID: baseProperties.gameID }),
      //   ...(userPropertyState.bcgId && { mvpd: userPropertyState.bcgId }),
      //   ...(baseProperties.channel && { channel: baseProperties.channel }),
      //   ...(baseProperties.gameState && { gameState: baseProperties.gameState }),
      // });
    }
  }, [pageInfo, previousPageInfo, updateBasePropertiesForScreenView]);

  useEffect(() => {
    if (userPropertyState.authStatus !== '') {
      AnalyticsUtil.identify({
        ...persistentPropertyState,
        ...userPropertyState,
        userId: userPropertyState.bcgId ?? undefined,
      });
    }
  }, [persistentPropertyState, userPropertyState]);

  useEffect(() => {
    let userPropertiesObject = {};
    if (authProperties != null && authProperties.userProperties) {
      const { adobeHashID, mvpd, mvpdDisplayName } = authProperties.userProperties;
      if (adobeHashID !== userPropertyStore().adobeHashID || mvpd !== userPropertyStore().mvpd) {
        userPropertiesObject = {
          adobeHashID: adobeHashID,
          mvpd: mvpd,
          mvpdDisplayName: mvpdDisplayName,
          adobeId: adobeId,
        };
      }
    }

    const authState = authProperties.state == AuthStateNames.AUTHENTICATED ? 'LOGGED_IN' : 'NOT_LOGGED_IN';
    const state = (authState +
      (freeViewState === FreeViewStateNames.USING_FREEVIEW ? '_REMAINING' : '_EXPIRED')) as keyof typeof UserStatusAuth;

    if (userPropertyStore().authStatus !== UserStatusAuth[state]) {
      userPropertyStore({
        ...userPropertyStore(),
        ...userPropertiesObject,
        authStatus: UserStatusAuth[state],
      });
    } else if (Object.keys(userPropertiesObject).length > 0) {
      userPropertyStore({
        ...userPropertyStore(),
        ...userPropertiesObject,
      });
    }
  }, [adobeId, authProperties, freeViewState]);
}
